// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Atom_Row = require("./Atom_Row.bs.js");
var Atom_Cell = require("./Atom_Cell.bs.js");
var Atom_Text = require("./Atom_Text.bs.js");
var UseToggle = require("../../hook/UseToggle.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Text_Ds = require("./Atom_Text_Ds.bs.js");
var Atom_Checkbox_Ds = require("./Atom_Checkbox_Ds.bs.js");
var Atom_Checkbox_Css = require("./Atom_Checkbox_Css.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");

function Atom_Checkbox$Internal(Props) {
  var requiredOpt = Props.required;
  var label = Props.label;
  var onChange = Props.onChange;
  var textStyle = Props.textStyle;
  var id = Props.id;
  var displayOrder = Props.displayOrder;
  var style = Props.style;
  var checkedOpt = Props.checked;
  var onBlur = Props.onBlur;
  var name = Props.name;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var checked = checkedOpt !== undefined ? checkedOpt : false;
  var match = UseToggle.make(UseToggle.toStatus(checked), (function (param) {
          Curry._1(onChange, true);
        }), (function (param) {
          Curry._1(onChange, false);
        }), undefined);
  var toggleRaw = match.toggleRaw;
  var __x = Atom_Checkbox_Css.toCss(style);
  var inputClass = CssJs.style(__x);
  var containerRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.cursor("pointer")]);
  var className = Cn.fromList({
        hd: inputClass,
        tl: /* [] */0
      });
  var handleOnChange = function (param) {
    Curry._1(toggleRaw, undefined);
  };
  var tmp = {
    alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
    children: null,
    innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS"),
    kind: {
      TAG: /* Label */8,
      _0: id
    },
    rules: containerRules,
    wrap: /* OnOneLine */1
  };
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  var tmp$1 = {
    className: className,
    id: id,
    checked: match.stateBoolean,
    required: required,
    type: "checkbox",
    onChange: handleOnChange
  };
  if (name !== undefined) {
    tmp$1.name = Caml_option.valFromOption(name);
  }
  if (onBlur !== undefined) {
    tmp$1.onBlur = Caml_option.valFromOption(onBlur);
  }
  return React.createElement(Atom_Row.make, tmp, React.createElement(Atom_Cell.make, {
                  children: React.createElement("input", tmp$1)
                }), React.createElement(Atom_Text.make, {
                  children: label,
                  kind: "span",
                  style: textStyle
                }));
}

var Internal = {
  make: Atom_Checkbox$Internal
};

function Atom_Checkbox(Props) {
  var requiredOpt = Props.required;
  var label = Props.label;
  var onChange = Props.onChange;
  var textStyle = Props.textStyle;
  var id = Props.id;
  var displayOrder = Props.displayOrder;
  var style = Props.style;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var tmp = {
    required: required,
    label: label,
    onChange: onChange,
    textStyle: textStyle,
    id: id,
    style: style
  };
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  return React.createElement(Atom_Checkbox$Internal, tmp);
}

function Atom_Checkbox$Mona(Props) {
  var requiredOpt = Props.required;
  var label = Props.label;
  var onClick = Props.onClick;
  var id = Props.id;
  var checkedOpt = Props.checked;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var checked = checkedOpt !== undefined ? checkedOpt : false;
  return React.createElement(Atom_Checkbox$Internal, {
              required: required,
              label: label,
              onChange: onClick,
              textStyle: Atom_Text_Ds.Mona.makeCheckbox,
              id: id,
              style: Atom_Checkbox_Ds.mona,
              checked: checked
            });
}

var Mona = {
  make: Atom_Checkbox$Mona
};

function Atom_Checkbox$Presse(Props) {
  var requiredOpt = Props.required;
  var label = Props.label;
  var onClick = Props.onClick;
  var id = Props.id;
  var checkedOpt = Props.checked;
  var onBlur = Props.onBlur;
  var name = Props.name;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var checked = checkedOpt !== undefined ? checkedOpt : false;
  var tmp = {
    required: required,
    label: label,
    onChange: onClick,
    textStyle: Atom_Text_Ds.Presse.makeCheckbox,
    id: id,
    style: Atom_Checkbox_Ds.presse,
    checked: checked
  };
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (name !== undefined) {
    tmp.name = Caml_option.valFromOption(name);
  }
  return React.createElement(Atom_Checkbox$Internal, tmp);
}

var Presse = {
  make: Atom_Checkbox$Presse
};

var make = Atom_Checkbox;

exports.Internal = Internal;
exports.make = make;
exports.Mona = Mona;
exports.Presse = Presse;
/* CssJs Not a pure module */
